import { render, staticRenderFns } from "./MLsportEuropeanCart.vue?vue&type=template&id=8d454082&scoped=true"
import script from "./MLsportEuropeanCart.vue?vue&type=script&lang=js"
export * from "./MLsportEuropeanCart.vue?vue&type=script&lang=js"
import style0 from "./MLsportEuropeanCart.vue?vue&type=style&index=0&id=8d454082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d454082",
  null
  
)

export default component.exports